<template>
    <a-config-provider :locale="ru_RU">
        <div id="app">
            <div class="page">
                <section class="content">
                    <router-view name="navbar" />
                    <router-view name="default" />
                </section>
                <section class="footer">
                    <router-view name="footer" />
                </section>
            </div>
        </div>
    </a-config-provider>
</template>

<script>
    import ru_RU from 'ant-design-vue/lib/locale-provider/ru_RU';


    export default {
        name: 'App',
        data() {
            return {
                ru_RU
            }
        }
    }
</script>

<style lang="scss">
    @import './assets/style/compile/style.scss';
</style>